var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LightboxVideo360Card',{key:this.currentVideoIndex,attrs:{"data":this.currentVideo},on:{"ended":function($event){return _vm.setNextVideo()},"loaded":() => {this.isVideoSet = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }